import React from 'react'
import { curry, dissoc } from 'ramda'

import Field from './Field'
import SelectMenu from './SelectMenu'
import Switch from './Switch'
import TimerInput from './TimerInput'
import Slider from './Slider'
import Checkbox from './Checkbox'

const createInputField = curry((tag, type, props) => (
  <Field
    {...props}
    type={type}
    render={(renderProps) => {
      // remove getPopupContainer as it's an invalid dom prop for inputs/textarea
      const newProps = dissoc('getPopupContainer', renderProps)
      return React.createElement(tag, { ...newProps, type }, null)
    }}
  />
))

const TextArea = createInputField('textarea', 'text')
const TextInput = createInputField('input', 'text')
const NumberInput = createInputField('input', 'number')

export {
  SelectMenu,
  TextArea,
  TextInput,
  NumberInput,
  Switch,
  TimerInput,
  Slider,
  Checkbox,
}
